
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "Auth",
  computed: {
    ...mapGetters({
        User: "userstate/getUser",
    }),
  },
  props: {
    scope: String,
    initiator: String,
    client_id: String,
    response_type: String,
    redirect_uri: String,
    state: String,
    unauthorized: String,
  },
  beforeMount() {
        if (window.location.href.indexOf('/auth/login/okta/response#access_token=') > -1 || window.location.href.indexOf('/auth/token/display?access_token=') > -1 ) {
            return;
        }
        else if (this.unauthorized === 'true'){
            this.$router.push({ name: 'Unauthorized'})
            return;
        }
        else if (this.User.isLoggedIn) {
            this.$router.push({ name: 'Documentation'})
            return;
        }
        else if ((this.scope === undefined || this.scope === "") && !window.location.href.endsWith('/auth/login/scopes') && !window.location.href.includes('/auth/token/display')) {
            this.$router.push({ name: 'Scopes'})
            return;
        }
  }
})
